<script setup lang="ts">
import { ElIcon, ElTooltip } from 'element-plus'
import { useSlots } from 'vue'

import HelpIcon from '../../assets/icons/help.svg?component'
import type { TypographyVariants } from '../types/ui'

import FlexComponent from './FlexComponent.vue'
import TypographyComponent from './TypographyComponent.vue'

withDefaults(defineProps<{ title?: string; variant?: TypographyVariants }>(), { variant: 'title-large' })
defineSlots<{ title?(): void; tooltip?(): void }>()

const slots = useSlots()
</script>
<template>
  <FlexComponent :gap="8" align="center">
    <slot v-if="$slots.title" name="title" />
    <TypographyComponent v-else :variant="variant">{{ title }}</TypographyComponent>
    <ElTooltip v-if="slots.tooltip" placement="top" effect="light" :show-arrow="false">
      <ElIcon :size="18" class="tooltip-handle">
        <HelpIcon />
      </ElIcon>
      <template #content>
        <slot name="tooltip" />
      </template>
    </ElTooltip>
  </FlexComponent>
</template>
<style lang="scss" scoped>
.tooltip-handle {
  cursor: pointer;
}
</style>
